import { useQuery } from "@apollo/react-hooks";
import { CategoryPage } from "@outschool/gql-backend-generated";

import { RandomCategoriesByFacetQuery } from "../queries/RandomCategoriesByFacet";

export type RandomCategoryFacet = Pick<
  CategoryPage,
  "uid" | "nameTitleCased" | "basePath" | "slug"
> & {
  searchFilters: Pick<CategoryPage["searchFilters"], "q">;
};

export const useRandomCategoriesByFacetQuery = (
  facet?: string,
  limit?: number
) =>
  useQuery<{
    randomCategoriesByFacet: RandomCategoryFacet[];
  }>(RandomCategoriesByFacetQuery, {
    variables: { facet, limit }
  });
